<template>
  <span class="inline-block bg-turquoise w-3 h-3 top-[12%] right-[12%] rounded-full outline outline-white/70 outline-1"></span>
</template>